/**
 * 完整的时区列表
 * 包含全球所有主要时区
 */

export default [
  // UTC-12 到 UTC-1
  { value: 'Etc/GMT+12', label: '(GMT-12:00) International Date Line West' },
  { value: 'Pacific/Midway', label: '(GMT-11:00) Midway Island, Samoa' },
  { value: 'Pacific/Honolulu', label: '(GMT-10:00) Hawaii' },
  { value: 'America/Anchorage', label: '(GMT-09:00) Alaska' },
  { value: 'America/Los_Angeles', label: '(GMT-08:00) Pacific Time (US & Canada)' },
  { value: 'America/Tijuana', label: '(GMT-08:00) Tijuana' },
  { value: 'America/Denver', label: '(GMT-07:00) Mountain Time (US & Canada)' },
  { value: 'America/Phoenix', label: '(GMT-07:00) Arizona' },
  { value: 'America/Chihuahua', label: '(GMT-07:00) Chihuahua, La Paz, Mazatlan' },
  { value: 'America/Chicago', label: '(GMT-06:00) Central Time (US & Canada)' },
  { value: 'America/Mexico_City', label: '(GMT-06:00) Guadalajara, Mexico City, Monterrey' },
  { value: 'America/Regina', label: '(GMT-06:00) Saskatchewan' },
  { value: 'America/Bogota', label: '(GMT-05:00) Bogota, Lima, Quito' },
  { value: 'America/New_York', label: '(GMT-05:00) Eastern Time (US & Canada)' },
  { value: 'America/Indiana/Indianapolis', label: '(GMT-05:00) Indiana (East)' },
  { value: 'America/Caracas', label: '(GMT-04:30) Caracas' },
  { value: 'America/Halifax', label: '(GMT-04:00) Atlantic Time (Canada)' },
  { value: 'America/La_Paz', label: '(GMT-04:00) Georgetown, La Paz, Manaus' },
  { value: 'America/Santiago', label: '(GMT-04:00) Santiago' },
  { value: 'America/St_Johns', label: '(GMT-03:30) Newfoundland' },
  { value: 'America/Sao_Paulo', label: '(GMT-03:00) Brasilia' },
  { value: 'America/Argentina/Buenos_Aires', label: '(GMT-03:00) Buenos Aires' },
  { value: 'America/Godthab', label: '(GMT-03:00) Greenland' },
  { value: 'America/Montevideo', label: '(GMT-03:00) Montevideo' },
  { value: 'Atlantic/South_Georgia', label: '(GMT-02:00) Mid-Atlantic' },
  { value: 'Atlantic/Azores', label: '(GMT-01:00) Azores' },
  { value: 'Atlantic/Cape_Verde', label: '(GMT-01:00) Cape Verde Is.' },
  
  // UTC+0
  { value: 'Europe/London', label: '(GMT+00:00) London, Edinburgh, Dublin' },
  { value: 'Etc/GMT', label: '(GMT+00:00) UTC' },
  { value: 'Africa/Casablanca', label: '(GMT+00:00) Casablanca, Monrovia' },
  
  // UTC+1 到 UTC+3
  { value: 'Europe/Berlin', label: '(GMT+01:00) Berlin, Rome, Paris, Madrid' },
  { value: 'Europe/Amsterdam', label: '(GMT+01:00) Amsterdam, Brussels, Vienna' },
  { value: 'Europe/Budapest', label: '(GMT+01:00) Budapest, Prague, Warsaw' },
  { value: 'Europe/Zurich', label: '(GMT+01:00) Bern, Zurich' },
  { value: 'Africa/Cairo', label: '(GMT+02:00) Cairo' },
  { value: 'Africa/Johannesburg', label: '(GMT+02:00) Johannesburg, Pretoria' },
  { value: 'Europe/Athens', label: '(GMT+02:00) Athens, Bucharest, Istanbul' },
  { value: 'Europe/Helsinki', label: '(GMT+02:00) Helsinki, Kyiv, Riga, Sofia, Tallinn, Vilnius' },
  { value: 'Asia/Jerusalem', label: '(GMT+02:00) Jerusalem' },
  { value: 'Africa/Nairobi', label: '(GMT+03:00) Nairobi' },
  { value: 'Europe/Moscow', label: '(GMT+03:00) Moscow, St. Petersburg, Volgograd' },
  { value: 'Asia/Baghdad', label: '(GMT+03:00) Baghdad' },
  { value: 'Asia/Kuwait', label: '(GMT+03:00) Kuwait, Riyadh' },
  { value: 'Asia/Tehran', label: '(GMT+03:30) Tehran' },
  
  // UTC+4 到 UTC+6
  { value: 'Asia/Dubai', label: '(GMT+04:00) Abu Dhabi, Muscat' },
  { value: 'Asia/Baku', label: '(GMT+04:00) Baku, Tbilisi, Yerevan' },
  { value: 'Asia/Kabul', label: '(GMT+04:30) Kabul' },
  { value: 'Asia/Karachi', label: '(GMT+05:00) Islamabad, Karachi' },
  { value: 'Asia/Tashkent', label: '(GMT+05:00) Tashkent' },
  { value: 'Asia/Kolkata', label: '(GMT+05:30) Chennai, Kolkata, Mumbai, New Delhi' },
  { value: 'Asia/Kathmandu', label: '(GMT+05:45) Kathmandu' },
  { value: 'Asia/Almaty', label: '(GMT+06:00) Almaty, Novosibirsk' },
  { value: 'Asia/Dhaka', label: '(GMT+06:00) Astana, Dhaka' },
  
  // UTC+7 到 UTC+8
  { value: 'Asia/Bangkok', label: '(GMT+07:00) Bangkok, Hanoi, Jakarta' },
  { value: 'Asia/Ho_Chi_Minh', label: '(GMT+07:00) Ho Chi Minh' },
  { value: 'Asia/Singapore', label: '(GMT+08:00) Singapore, Kuala Lumpur' },
  { value: 'Asia/Shanghai', label: '(GMT+08:00) Beijing, Shanghai, Hong Kong' },
  { value: 'Asia/Taipei', label: '(GMT+08:00) Taipei' },
  { value: 'Asia/Manila', label: '(GMT+08:00) Manila' },
  { value: 'Asia/Ulaanbaatar', label: '(GMT+08:00) Ulaanbaatar' },
  { value: 'Australia/Perth', label: '(GMT+08:00) Perth' },
  
  // UTC+9 到 UTC+10
  { value: 'Asia/Tokyo', label: '(GMT+09:00) Tokyo, Osaka, Sapporo' },
  { value: 'Asia/Seoul', label: '(GMT+09:00) Seoul' },
  { value: 'Asia/Yakutsk', label: '(GMT+09:00) Yakutsk' },
  { value: 'Australia/Darwin', label: '(GMT+09:30) Darwin' },
  { value: 'Australia/Adelaide', label: '(GMT+10:30) Adelaide' },
  { value: 'Australia/Sydney', label: '(GMT+10:00) Sydney, Melbourne' },
  { value: 'Australia/Brisbane', label: '(GMT+10:00) Brisbane' },
  { value: 'Pacific/Guam', label: '(GMT+10:00) Guam, Port Moresby' },
  { value: 'Asia/Vladivostok', label: '(GMT+10:00) Vladivostok' },
  
  // UTC+11 到 UTC+12
  { value: 'Asia/Magadan', label: '(GMT+11:00) Magadan, Solomon Is., New Caledonia' },
  { value: 'Pacific/Fiji', label: '(GMT+12:00) Fiji, Kamchatka, Marshall Is.' },
  { value: 'Pacific/Auckland', label: '(GMT+12:00) Auckland, Wellington' },
  
  // UTC+13 到 UTC+14
  { value: 'Pacific/Tongatapu', label: '(GMT+13:00) Nukualofa' },
  { value: 'Pacific/Kiritimati', label: '(GMT+14:00) Kiritimati' }
]



// WEBPACK FOOTER //
// ./src/utils/timezones.js